import { Store } from 'redux'
import { SagaMiddleware } from 'redux-saga'
import { cancel, fork, take } from 'redux-saga/effects'
import { appSagas } from './appSagas'

const sagas = [appSagas]

export const CANCEL_SAGAS_HMR = 'CANCEL_SAGAS_HMR'

function createAbortableSaga(saga: any) {
  if (process.env.NODE_ENV === 'development') {
    return function* main() {
      // @ts-ignore
      const sagaTask = yield fork(saga)

      yield take(CANCEL_SAGAS_HMR)
      yield cancel(sagaTask)
    }
  }

  return saga
}

export const sagaManager = {
  startSagas(sagaMiddleware: SagaMiddleware) {
    sagas.map(createAbortableSaga).forEach((saga) => sagaMiddleware.run(saga))
  },
  cancelSagas(store: Store) {
    store.dispatch({ type: CANCEL_SAGAS_HMR })
  },
}
